<template>
    <ul class="article-list">
        <li v-for="(item,index) in newList" :key="index" @click="$router.push({'path':`/celebrity/detail/${item.shopId}/article/detail/${item.id}`})">
            <div class="fl info">
                <h3 class="title">{{item.title}}</h3>
                <p class="desc">
                    <span class="desc-txt" v-html="$common.interceptStr(item.desc,80)"></span>
                </p>
                <a class="btn-read">阅读全文</a>
                <p class="time"><i class="el-icon-time"></i>{{item.createTime}}</p>
            </div>
            <img class="fr img" :src="$common.imgPath(item.img)" />
        </li>
    </ul>
</template>
<script>
    export default {
        props:{
            newList:[Array]
        },
        data(){
            return {

            }
        },
        filters:{

        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/css/common';
    .article-list{
        padding-bottom:80px;
        li{
            overflow: hidden;
            padding:24px 21px;
            border-bottom:1px solid #EEEEEE;
            .info{
                width:530px;
                .title{
                    font-size:26px;
                    color:#222222;
                    line-height:42px;
                }
                .desc{
                    font-size:16px;
                    color:#565656;
                    line-height:25px;

                }
                .btn-read{
                    font-weight:600;
                    line-height: 40px;
                }
                .time{
                    color:#999999;
                    font-size:16px;
                    line-height:42px;
                }
            }
            .img{
                width:170px;
                height:170px;
                background-color:$main-color;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                border-radius: 10px;
            }

        }
    }
</style>